import _each from 'lodash/each'
import _filter from 'lodash/filter'

function buildCatTree (data, cat) {
  return _each(_filter(data, { category: cat }), item => {
    if (item.type === 'category') {
      item.lessons = this.buildCatTree(data, item.id)
    }

    return item
  })
}

export default {
  buildCatTree
}



// WEBPACK FOOTER //
// ./src/components/Training/list/lib/index.js